import { FirebaseDocumentDataType } from 'firebase/index'
import { CheckoutItemType } from 'types/checkoutItem'
import { OrderType } from 'types/checkout'

const mergeCheckoutWithItems = (
  checkoutSnapshots: FirebaseDocumentDataType,
  items: CheckoutItemType[]
): OrderType[] => {
  const orders: OrderType[] = []
  for (let i = 0; i < checkoutSnapshots.docs.length; i = (i + 1) | 0) {
    const snapshot = checkoutSnapshots.docs[i]
    const data: OrderType = snapshot.data()
    data.checkout_id = snapshot.id
    data.items = items.filter((item) => item.checkout_id === snapshot.id)
    if (data.items.length === 0) continue // 注文がない場合
    orders.push(data)
  }
  return orders
}

export default mergeCheckoutWithItems
